// 중간에 페이지가 새로고침되면 사용자의 작업이 사라지는 구간(배송 사진 촬영,
// 아직 전송하지 않은 사진 보유, 업로드 진행 중)을 표시하기 위한 카운터.
// 서비스워커가 업데이트되어도 이 구간이 끝날 때까지 새로고침을 미룬다.

let busyCount = 0;
const idleListeners = new Set();

/**
 * 작업 시작을 알린다.
 * @returns {() => void} 작업 종료 시 호출할 해제 함수 (여러 번 호출해도 안전)
 */
export function markBusy() {
  busyCount += 1;

  let released = false;
  return () => {
    if (released) {
      return;
    }
    released = true;
    busyCount -= 1;

    if (busyCount === 0) {
      // 리스너가 구독을 해제하며 순회 중인 Set을 변경할 수 있어 복사본을 돈다
      for (const listener of [...idleListeners]) {
        listener();
      }
    }
  };
}

export function isBusy() {
  return busyCount > 0;
}

/**
 * 진행 중인 작업이 모두 끝나는 시점에 호출된다.
 * @returns {() => void} 구독 해제 함수
 */
export function onIdle(listener) {
  idleListeners.add(listener);
  return () => idleListeners.delete(listener);
}
